
export class DeviceManager {
  public id?: number
  public deviceName?: string
  public deviceOs?: string
  public deviceId?: string
  public lastLoginAt?: string
  public isLogin?: boolean

  constructor(
    id?: number,
    deviceName?: string,
    deviceOs?: string,
    deviceId?: string,
    lastLoginAt?: string,
    isLogin?: boolean
  ) {
    this.id = id
    this.deviceName = deviceName
    this.deviceOs = deviceOs
    this.deviceId = deviceId
    this.lastLoginAt = lastLoginAt
    this.isLogin = isLogin
  }
}